import { useCallback } from 'react';

import { identityHttpClient } from '@/services/http/clients/identityHttpClient';

export function useGetApplicationSubscriptionName() {
  const getApplicationSubscriptionName = useCallback(async () => {
    const requestUrl = '/applicationsubscription/name';
    const response = await identityHttpClient.get<string>(requestUrl);
    return response.data;
  }, []);

  return {
    getApplicationSubscriptionName,
  } as const;
}